<template>
  <div class="slider">
    <div class="slider_header" v-if="hasCards && cards.length > 1">
      <div class="slider_title">
        <h1 class="heading1">{{ $t('Мои карты') }}</h1>
      </div>

      <div class="slider_preview">
        <CardSwitcher :cards="cards" />
      </div>

      <div class="slider_title slider_title__ghost">
        <h1 class="heading1">{{ $t('Мои карты') }}</h1>
      </div>
    </div>

    <div class="slider_item">
      <Transition name="page-transition" mode="out-in" appear>
        <RouterView v-if="hasCards" :key="$route.params.cardCode" />
        <CardPlaceholder v-else />
      </Transition>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import CardPicture from '@/components/Card/CardPicture.vue'
import CardPlaceholder from '@/components/Card/CardPlaceholder.vue'
import CardSwitcher from '@/components/CardSwitcher.vue'

const cards = namespace('cards')

@Component({
  components: { CardPicture, CardPlaceholder, CardSwitcher }
})
class MyCards extends Vue {
  @cards.State cards
  @cards.Getter cardByCode

  beforeRouteEnter (to, from, next) {
    next(vm => { to.name === 'cards' && vm.redirectToDefaultCard() })
  }

  beforeRouteUpdate (to, from, next) {
    if (to.name === 'cards') {
      return this.redirectToDefaultCard()
    }

    if (from.name === 'card_detail' && to.name === 'card_detail') {
      this.$analytics.trackCardChange({
        screenId: this.$route.name,
        fromCard: this.cardByCode(from.params.cardCode),
        toCard: this.cardByCode(to.params.cardCode)
      })
    }
    next()
  }

  get hasCards () {
    return this.cards.length > 0
  }

  redirectToDefaultCard () {
    const defaultCard = this.cards[0]
    if (defaultCard) {
      this.$router.replace({
        name: 'card_detail',
        params: { cardCode: defaultCard.cardCode }
      })
    }
  }
}

export default MyCards
</script>

<style lang="scss">
.page-transition {
  &-enter-active, &-leave-active {
    transition: all .3s ease-in-out;
  }

  &-enter, &-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
}

  .slider {
    &_header {
      @extend %layout;
      @include media_tablet {
        align-items: center;
        display: flex;
        justify-content: space-between;
      }
    }
    &_title {
      margin: 23px 0 18px;
      @include media_tablet {
        flex: 0 0 auto;
        margin: 0 40px 0 0;
      }

      &__ghost { /* only for positioning of .slider_preview */
        display: none;
        @include media_desktop {
          display: block;
          visibility: hidden;
        }
      }
    }
    &_preview {
      margin: 0 -6px 13px;
      @include media_tablet {
        flex: 0 1 auto;
        margin: 15px auto;
        overflow: hidden;
      }
    }
    &_swiper {
      width: auto;
    }
    &_link {
      border: 1px solid transparent;
      border-radius: 3px;
      display: block;
      margin: 1px;
      opacity: .7;
      padding: 5px;
      text-decoration: none;
      transition: border-color $duration ease,
                  opacity $duration ease;
      width: 73px;
      @include media_tablet {
        width: 105px;
      }

      &:hover {
        border-color: #666;
        opacity: 1;
      }
      &__active,
      &__active:hover {
        border-color: #ff8000;
        cursor: default;
        opacity: 1;
      }
    }
    &_item {
      border-top: 1px solid #303030;
    }
  }
</style>
